<template>
    <div class="header-bar">
        <a @click="handleCollpasedChange" type="text" :class="['sider-trigger-a', collapsed ? 'collapsed' : '']">
            <Icon type="md-menu" size="26"/>
        </a>
        <custom-bread-crumb show-icon style="margin-left: 30px;" :list="breadCrumbList"/>
        <div class="custom-content-con">
            <full-screen/>
            <lock-screen/>
            <lang-switch/>
            <user/>
        </div>
    </div>
</template>
<script>
import customBreadCrumb from './custom-bread-crumb.vue';
import user from './user.vue';
import lockScreen from './lockscreen/lock-screen.vue';
import fullScreen from './full-screen.vue';
import langSwitch from './lang-switch.vue';

export default {
    name: 'headerBar',
    components: {
        customBreadCrumb,
        lockScreen,
        fullScreen,
        langSwitch,
        user,
    },
    props: {
        collapsed: Boolean,
    },
    computed: {
        userAvator() {
            return this.$store.state.user.myInfo.avatar;
        },
        breadCrumbList() {
            return this.$store.state.app.breadCrumbList;
        },
    },
    methods: {
        handleCollpasedChange() {
            this.$emit('on-collapsed-change', !this.collapsed);
        },
    },
};
</script>
<style lang="less" scoped>
.header-bar {
    width: 100%;
    height: 100%;
    position: relative;
    .custom-content-con {
        float: right;
        height: auto;
        padding-right: 20px;
    }

    .trans {
        transition: transform 0.2s ease;
    }
    @size: 40px;
    .sider-trigger-a {
        padding: 6px;
        width: @size;
        height: @size;
        display: inline-block;
        text-align: center;
        color: #5c6b77;
        margin-top: 12px;
        i {
            .trans;
            vertical-align: top;
        }
        &.collapsed i {
            transform: rotateZ(90deg);
            .trans;
        }
    }
}
</style>
